// extracted by mini-css-extract-plugin
export default {"mainContent":"DepositHistory_mainContent__fBNeU"};